/* This component is auto-generated with figma-svg. */
import { ComponentType } from 'react';

import AdjustmentsScaleMedium from 'bloko/blocks/icon/variants/icon/AdjustmentsScaleMedium';
import AdjustmentsScaleSmall from 'bloko/blocks/icon/variants/icon/AdjustmentsScaleSmall';
import ArrowLineScaleMedium from 'bloko/blocks/icon/variants/icon/ArrowLineScaleMedium';
import ArrowLineScaleSmall from 'bloko/blocks/icon/variants/icon/ArrowLineScaleSmall';
import ArrowPathScaleMediumKindClockwise from 'bloko/blocks/icon/variants/icon/ArrowPathScaleMediumKindClockwise';
import ArrowPathScaleMediumKindDefault from 'bloko/blocks/icon/variants/icon/ArrowPathScaleMediumKindDefault';
import ArrowPathScaleSmallKindClockwise from 'bloko/blocks/icon/variants/icon/ArrowPathScaleSmallKindClockwise';
import ArrowPathScaleSmallKindDefault from 'bloko/blocks/icon/variants/icon/ArrowPathScaleSmallKindDefault';
import ArrowRectangleScaleMedium from 'bloko/blocks/icon/variants/icon/ArrowRectangleScaleMedium';
import ArrowRectangleScaleSmall from 'bloko/blocks/icon/variants/icon/ArrowRectangleScaleSmall';
import ArrowScaleMediumKindDown from 'bloko/blocks/icon/variants/icon/ArrowScaleMediumKindDown';
import ArrowScaleMediumKindLeft from 'bloko/blocks/icon/variants/icon/ArrowScaleMediumKindLeft';
import ArrowScaleMediumKindLeftUp from 'bloko/blocks/icon/variants/icon/ArrowScaleMediumKindLeftUp';
import ArrowScaleMediumKindRight from 'bloko/blocks/icon/variants/icon/ArrowScaleMediumKindRight';
import ArrowScaleMediumKindUp from 'bloko/blocks/icon/variants/icon/ArrowScaleMediumKindUp';
import ArrowScaleMediumKindUpDown from 'bloko/blocks/icon/variants/icon/ArrowScaleMediumKindUpDown';
import ArrowScaleSmallKindDown from 'bloko/blocks/icon/variants/icon/ArrowScaleSmallKindDown';
import ArrowScaleSmallKindLeft from 'bloko/blocks/icon/variants/icon/ArrowScaleSmallKindLeft';
import ArrowScaleSmallKindLeftUp from 'bloko/blocks/icon/variants/icon/ArrowScaleSmallKindLeftUp';
import ArrowScaleSmallKindRight from 'bloko/blocks/icon/variants/icon/ArrowScaleSmallKindRight';
import ArrowScaleSmallKindUp from 'bloko/blocks/icon/variants/icon/ArrowScaleSmallKindUp';
import ArrowScaleSmallKindUpDown from 'bloko/blocks/icon/variants/icon/ArrowScaleSmallKindUpDown';
import ArrowSquareScaleMedium from 'bloko/blocks/icon/variants/icon/ArrowSquareScaleMedium';
import ArrowSquareScaleSmall from 'bloko/blocks/icon/variants/icon/ArrowSquareScaleSmall';
import ArrowsScaleMediumKindDefault from 'bloko/blocks/icon/variants/icon/ArrowsScaleMediumKindDefault';
import ArrowsScaleMediumKindDiagonalIn from 'bloko/blocks/icon/variants/icon/ArrowsScaleMediumKindDiagonalIn';
import ArrowsScaleMediumKindDiagonalOut from 'bloko/blocks/icon/variants/icon/ArrowsScaleMediumKindDiagonalOut';
import ArrowsScaleSmallKindDefault from 'bloko/blocks/icon/variants/icon/ArrowsScaleSmallKindDefault';
import ArrowsScaleSmallKindDiagonalIn from 'bloko/blocks/icon/variants/icon/ArrowsScaleSmallKindDiagonalIn';
import ArrowsScaleSmallKindDiagonalOut from 'bloko/blocks/icon/variants/icon/ArrowsScaleSmallKindDiagonalOut';
import AstrostarScaleMedium from 'bloko/blocks/icon/variants/icon/AstrostarScaleMedium';
import AstrostarScaleSmall from 'bloko/blocks/icon/variants/icon/AstrostarScaleSmall';
import BanScaleMedium from 'bloko/blocks/icon/variants/icon/BanScaleMedium';
import BanScaleSmall from 'bloko/blocks/icon/variants/icon/BanScaleSmall';
import BarsScaleMedium from 'bloko/blocks/icon/variants/icon/BarsScaleMedium';
import BarsScaleSmall from 'bloko/blocks/icon/variants/icon/BarsScaleSmall';
import BellScaleMediumCrossedFalse from 'bloko/blocks/icon/variants/icon/BellScaleMediumCrossedFalse';
import BellScaleMediumCrossedTrue from 'bloko/blocks/icon/variants/icon/BellScaleMediumCrossedTrue';
import BellScaleSmallCrossedFalse from 'bloko/blocks/icon/variants/icon/BellScaleSmallCrossedFalse';
import BellScaleSmallCrossedTrue from 'bloko/blocks/icon/variants/icon/BellScaleSmallCrossedTrue';
import BoltScaleMedium from 'bloko/blocks/icon/variants/icon/BoltScaleMedium';
import BoltScaleSmall from 'bloko/blocks/icon/variants/icon/BoltScaleSmall';
import BookScaleMedium from 'bloko/blocks/icon/variants/icon/BookScaleMedium';
import BookScaleSmall from 'bloko/blocks/icon/variants/icon/BookScaleSmall';
import BotScaleMedium from 'bloko/blocks/icon/variants/icon/BotScaleMedium';
import BotScaleSmall from 'bloko/blocks/icon/variants/icon/BotScaleSmall';
import BoxScaleMediumKindArrow from 'bloko/blocks/icon/variants/icon/BoxScaleMediumKindArrow';
import BoxScaleMediumKindDefault from 'bloko/blocks/icon/variants/icon/BoxScaleMediumKindDefault';
import BoxScaleSmallKindArrow from 'bloko/blocks/icon/variants/icon/BoxScaleSmallKindArrow';
import BoxScaleSmallKindDefault from 'bloko/blocks/icon/variants/icon/BoxScaleSmallKindDefault';
import BriefcaseScaleMedium from 'bloko/blocks/icon/variants/icon/BriefcaseScaleMedium';
import BriefcaseScaleSmall from 'bloko/blocks/icon/variants/icon/BriefcaseScaleSmall';
import BubbleScaleMediumKindDoubleAppearanceOutlinedShapeRound from 'bloko/blocks/icon/variants/icon/BubbleScaleMediumKindDoubleAppearanceOutlinedShapeRound';
import BubbleScaleMediumKindSingleAppearanceFilledShapeRound from 'bloko/blocks/icon/variants/icon/BubbleScaleMediumKindSingleAppearanceFilledShapeRound';
import BubbleScaleMediumKindSingleAppearanceFilledShapeSquare from 'bloko/blocks/icon/variants/icon/BubbleScaleMediumKindSingleAppearanceFilledShapeSquare';
import BubbleScaleMediumKindSingleAppearanceOutlinedShapeRound from 'bloko/blocks/icon/variants/icon/BubbleScaleMediumKindSingleAppearanceOutlinedShapeRound';
import BubbleScaleMediumKindSingleAppearanceOutlinedShapeSquare from 'bloko/blocks/icon/variants/icon/BubbleScaleMediumKindSingleAppearanceOutlinedShapeSquare';
import BubbleScaleSmallKindDoubleAppearanceOutlinedShapeRound from 'bloko/blocks/icon/variants/icon/BubbleScaleSmallKindDoubleAppearanceOutlinedShapeRound';
import BubbleScaleSmallKindSingleAppearanceFilledShapeRound from 'bloko/blocks/icon/variants/icon/BubbleScaleSmallKindSingleAppearanceFilledShapeRound';
import BubbleScaleSmallKindSingleAppearanceFilledShapeSquare from 'bloko/blocks/icon/variants/icon/BubbleScaleSmallKindSingleAppearanceFilledShapeSquare';
import BubbleScaleSmallKindSingleAppearanceOutlinedShapeRound from 'bloko/blocks/icon/variants/icon/BubbleScaleSmallKindSingleAppearanceOutlinedShapeRound';
import BubbleScaleSmallKindSingleAppearanceOutlinedShapeSquare from 'bloko/blocks/icon/variants/icon/BubbleScaleSmallKindSingleAppearanceOutlinedShapeSquare';
import CalendarScaleMedium from 'bloko/blocks/icon/variants/icon/CalendarScaleMedium';
import CalendarScaleSmall from 'bloko/blocks/icon/variants/icon/CalendarScaleSmall';
import CameraScaleMedium from 'bloko/blocks/icon/variants/icon/CameraScaleMedium';
import CameraScaleSmall from 'bloko/blocks/icon/variants/icon/CameraScaleSmall';
import CartScaleMedium from 'bloko/blocks/icon/variants/icon/CartScaleMedium';
import CartScaleSmall from 'bloko/blocks/icon/variants/icon/CartScaleSmall';
import ChartScaleMediumKindBar from 'bloko/blocks/icon/variants/icon/ChartScaleMediumKindBar';
import ChartScaleMediumKindLine from 'bloko/blocks/icon/variants/icon/ChartScaleMediumKindLine';
import ChartScaleSmallKindBar from 'bloko/blocks/icon/variants/icon/ChartScaleSmallKindBar';
import ChartScaleSmallKindLine from 'bloko/blocks/icon/variants/icon/ChartScaleSmallKindLine';
import CheckmarkScaleExtraSmallKindDoubleAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/CheckmarkScaleExtraSmallKindDoubleAppearanceOutlinedEnclosedFalse';
import CheckmarkScaleExtraSmallKindSingleAppearanceFilledEnclosedTrue from 'bloko/blocks/icon/variants/icon/CheckmarkScaleExtraSmallKindSingleAppearanceFilledEnclosedTrue';
import CheckmarkScaleExtraSmallKindSingleAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/CheckmarkScaleExtraSmallKindSingleAppearanceOutlinedEnclosedFalse';
import CheckmarkScaleExtraSmallKindSingleAppearanceOutlinedEnclosedTrue from 'bloko/blocks/icon/variants/icon/CheckmarkScaleExtraSmallKindSingleAppearanceOutlinedEnclosedTrue';
import CheckmarkScaleMediumKindDoubleAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/CheckmarkScaleMediumKindDoubleAppearanceOutlinedEnclosedFalse';
import CheckmarkScaleMediumKindSingleAppearanceFilledEnclosedTrue from 'bloko/blocks/icon/variants/icon/CheckmarkScaleMediumKindSingleAppearanceFilledEnclosedTrue';
import CheckmarkScaleMediumKindSingleAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/CheckmarkScaleMediumKindSingleAppearanceOutlinedEnclosedFalse';
import CheckmarkScaleMediumKindSingleAppearanceOutlinedEnclosedTrue from 'bloko/blocks/icon/variants/icon/CheckmarkScaleMediumKindSingleAppearanceOutlinedEnclosedTrue';
import CheckmarkScaleSmallKindDoubleAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/CheckmarkScaleSmallKindDoubleAppearanceOutlinedEnclosedFalse';
import CheckmarkScaleSmallKindSingleAppearanceFilledEnclosedTrue from 'bloko/blocks/icon/variants/icon/CheckmarkScaleSmallKindSingleAppearanceFilledEnclosedTrue';
import CheckmarkScaleSmallKindSingleAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/CheckmarkScaleSmallKindSingleAppearanceOutlinedEnclosedFalse';
import CheckmarkScaleSmallKindSingleAppearanceOutlinedEnclosedTrue from 'bloko/blocks/icon/variants/icon/CheckmarkScaleSmallKindSingleAppearanceOutlinedEnclosedTrue';
import ChevronScaleExtraSmallKindDown from 'bloko/blocks/icon/variants/icon/ChevronScaleExtraSmallKindDown';
import ChevronScaleExtraSmallKindLeft from 'bloko/blocks/icon/variants/icon/ChevronScaleExtraSmallKindLeft';
import ChevronScaleExtraSmallKindRight from 'bloko/blocks/icon/variants/icon/ChevronScaleExtraSmallKindRight';
import ChevronScaleExtraSmallKindUp from 'bloko/blocks/icon/variants/icon/ChevronScaleExtraSmallKindUp';
import ChevronScaleExtraSmallKindUpDown from 'bloko/blocks/icon/variants/icon/ChevronScaleExtraSmallKindUpDown';
import ChevronScaleMediumKindDown from 'bloko/blocks/icon/variants/icon/ChevronScaleMediumKindDown';
import ChevronScaleMediumKindLeft from 'bloko/blocks/icon/variants/icon/ChevronScaleMediumKindLeft';
import ChevronScaleMediumKindRight from 'bloko/blocks/icon/variants/icon/ChevronScaleMediumKindRight';
import ChevronScaleMediumKindUp from 'bloko/blocks/icon/variants/icon/ChevronScaleMediumKindUp';
import ChevronScaleMediumKindUpDown from 'bloko/blocks/icon/variants/icon/ChevronScaleMediumKindUpDown';
import ChevronScaleSmallKindDown from 'bloko/blocks/icon/variants/icon/ChevronScaleSmallKindDown';
import ChevronScaleSmallKindLeft from 'bloko/blocks/icon/variants/icon/ChevronScaleSmallKindLeft';
import ChevronScaleSmallKindRight from 'bloko/blocks/icon/variants/icon/ChevronScaleSmallKindRight';
import ChevronScaleSmallKindUp from 'bloko/blocks/icon/variants/icon/ChevronScaleSmallKindUp';
import ChevronScaleSmallKindUpDown from 'bloko/blocks/icon/variants/icon/ChevronScaleSmallKindUpDown';
import CircleScaleMiddleAppearanceFilled from 'bloko/blocks/icon/variants/icon/CircleScaleMiddleAppearanceFilled';
import CircleScaleMiddleAppearanceOutlined from 'bloko/blocks/icon/variants/icon/CircleScaleMiddleAppearanceOutlined';
import CircleScaleSmallAppearanceFilled from 'bloko/blocks/icon/variants/icon/CircleScaleSmallAppearanceFilled';
import CircleScaleSmallAppearanceOutlined from 'bloko/blocks/icon/variants/icon/CircleScaleSmallAppearanceOutlined';
import ClipScaleMedium from 'bloko/blocks/icon/variants/icon/ClipScaleMedium';
import ClipScaleSmall from 'bloko/blocks/icon/variants/icon/ClipScaleSmall';
import ClockScaleExtraSmallKindDefault from 'bloko/blocks/icon/variants/icon/ClockScaleExtraSmallKindDefault';
import ClockScaleExtraSmallKindRewind from 'bloko/blocks/icon/variants/icon/ClockScaleExtraSmallKindRewind';
import ClockScaleMediumKindDefault from 'bloko/blocks/icon/variants/icon/ClockScaleMediumKindDefault';
import ClockScaleMediumKindRewind from 'bloko/blocks/icon/variants/icon/ClockScaleMediumKindRewind';
import ClockScaleSmallKindDefault from 'bloko/blocks/icon/variants/icon/ClockScaleSmallKindDefault';
import ClockScaleSmallKindRewind from 'bloko/blocks/icon/variants/icon/ClockScaleSmallKindRewind';
import CrossScaleMediumEnclosedFalse from 'bloko/blocks/icon/variants/icon/CrossScaleMediumEnclosedFalse';
import CrossScaleMediumEnclosedTrue from 'bloko/blocks/icon/variants/icon/CrossScaleMediumEnclosedTrue';
import CrossScaleSmallEnclosedFalse from 'bloko/blocks/icon/variants/icon/CrossScaleSmallEnclosedFalse';
import CrossScaleSmallEnclosedTrue from 'bloko/blocks/icon/variants/icon/CrossScaleSmallEnclosedTrue';
import DataflowScaleMedium from 'bloko/blocks/icon/variants/icon/DataflowScaleMedium';
import DataflowScaleSmall from 'bloko/blocks/icon/variants/icon/DataflowScaleSmall';
import DocumentScaleMedium from 'bloko/blocks/icon/variants/icon/DocumentScaleMedium';
import DocumentScaleSmall from 'bloko/blocks/icon/variants/icon/DocumentScaleSmall';
import DotsScaleMedium from 'bloko/blocks/icon/variants/icon/DotsScaleMedium';
import DotsScaleSmall from 'bloko/blocks/icon/variants/icon/DotsScaleSmall';
import DrawerScaleMedium from 'bloko/blocks/icon/variants/icon/DrawerScaleMedium';
import DrawerScaleSmall from 'bloko/blocks/icon/variants/icon/DrawerScaleSmall';
import EllipsisScaleMediumKindHorizontal from 'bloko/blocks/icon/variants/icon/EllipsisScaleMediumKindHorizontal';
import EllipsisScaleMediumKindVertical from 'bloko/blocks/icon/variants/icon/EllipsisScaleMediumKindVertical';
import EllipsisScaleSmallKindHorizontal from 'bloko/blocks/icon/variants/icon/EllipsisScaleSmallKindHorizontal';
import EllipsisScaleSmallKindVertical from 'bloko/blocks/icon/variants/icon/EllipsisScaleSmallKindVertical';
import EnvelopeScaleMediumKindDefault from 'bloko/blocks/icon/variants/icon/EnvelopeScaleMediumKindDefault';
import EnvelopeScaleMediumKindOpened from 'bloko/blocks/icon/variants/icon/EnvelopeScaleMediumKindOpened';
import EnvelopeScaleSmallKindDefault from 'bloko/blocks/icon/variants/icon/EnvelopeScaleSmallKindDefault';
import EnvelopeScaleSmallKindOpened from 'bloko/blocks/icon/variants/icon/EnvelopeScaleSmallKindOpened';
import ExclamationScaleMediumShapeCircle from 'bloko/blocks/icon/variants/icon/ExclamationScaleMediumShapeCircle';
import ExclamationScaleMediumShapeTriangle from 'bloko/blocks/icon/variants/icon/ExclamationScaleMediumShapeTriangle';
import ExclamationScaleSmallShapeCircle from 'bloko/blocks/icon/variants/icon/ExclamationScaleSmallShapeCircle';
import ExclamationScaleSmallShapeTriangle from 'bloko/blocks/icon/variants/icon/ExclamationScaleSmallShapeTriangle';
import EyeScaleMediumCrossedFalse from 'bloko/blocks/icon/variants/icon/EyeScaleMediumCrossedFalse';
import EyeScaleMediumCrossedTrue from 'bloko/blocks/icon/variants/icon/EyeScaleMediumCrossedTrue';
import EyeScaleMediumSmallCrossedFalse from 'bloko/blocks/icon/variants/icon/EyeScaleMediumSmallCrossedFalse';
import EyeScaleMediumSmallCrossedTrue from 'bloko/blocks/icon/variants/icon/EyeScaleMediumSmallCrossedTrue';
import EyeScaleSmallCrossedFalse from 'bloko/blocks/icon/variants/icon/EyeScaleSmallCrossedFalse';
import EyeScaleSmallCrossedTrue from 'bloko/blocks/icon/variants/icon/EyeScaleSmallCrossedTrue';
import FlagScaleMedium from 'bloko/blocks/icon/variants/icon/FlagScaleMedium';
import FlagScaleSmall from 'bloko/blocks/icon/variants/icon/FlagScaleSmall';
import FolderKindArrowScaleMedium from 'bloko/blocks/icon/variants/icon/FolderKindArrowScaleMedium';
import FolderKindArrowScaleSmall from 'bloko/blocks/icon/variants/icon/FolderKindArrowScaleSmall';
import FolderKindDefaultScaleMedium from 'bloko/blocks/icon/variants/icon/FolderKindDefaultScaleMedium';
import FolderKindDefaultScaleSmall from 'bloko/blocks/icon/variants/icon/FolderKindDefaultScaleSmall';
import FolderKindHeartScaleMedium from 'bloko/blocks/icon/variants/icon/FolderKindHeartScaleMedium';
import FolderKindHeartScaleSmall from 'bloko/blocks/icon/variants/icon/FolderKindHeartScaleSmall';
import FunnelScaleMedium from 'bloko/blocks/icon/variants/icon/FunnelScaleMedium';
import FunnelScaleSmall from 'bloko/blocks/icon/variants/icon/FunnelScaleSmall';
import GearScaleMedium from 'bloko/blocks/icon/variants/icon/GearScaleMedium';
import GearScaleSmall from 'bloko/blocks/icon/variants/icon/GearScaleSmall';
import GhostScaleMedium from 'bloko/blocks/icon/variants/icon/GhostScaleMedium';
import GhostScaleSmall from 'bloko/blocks/icon/variants/icon/GhostScaleSmall';
import GiftScaleMedium from 'bloko/blocks/icon/variants/icon/GiftScaleMedium';
import GiftScaleSmall from 'bloko/blocks/icon/variants/icon/GiftScaleSmall';
import GlobeScaleMedium from 'bloko/blocks/icon/variants/icon/GlobeScaleMedium';
import GlobeScaleSmall from 'bloko/blocks/icon/variants/icon/GlobeScaleSmall';
import GridScaleMedium from 'bloko/blocks/icon/variants/icon/GridScaleMedium';
import GridScaleSmall from 'bloko/blocks/icon/variants/icon/GridScaleSmall';
import HeartScaleMediumAppearanceFilled from 'bloko/blocks/icon/variants/icon/HeartScaleMediumAppearanceFilled';
import HeartScaleMediumAppearanceOutlined from 'bloko/blocks/icon/variants/icon/HeartScaleMediumAppearanceOutlined';
import HeartScaleMediumSmallAppearanceFilled from 'bloko/blocks/icon/variants/icon/HeartScaleMediumSmallAppearanceFilled';
import HeartScaleMediumSmallAppearanceOutlined from 'bloko/blocks/icon/variants/icon/HeartScaleMediumSmallAppearanceOutlined';
import HeartScaleSmallAppearanceFilled from 'bloko/blocks/icon/variants/icon/HeartScaleSmallAppearanceFilled';
import HeartScaleSmallAppearanceOutlined from 'bloko/blocks/icon/variants/icon/HeartScaleSmallAppearanceOutlined';
import InfoScaleMedium from 'bloko/blocks/icon/variants/icon/InfoScaleMedium';
import InfoScaleSmall from 'bloko/blocks/icon/variants/icon/InfoScaleSmall';
import LifebuoyScaleMedium from 'bloko/blocks/icon/variants/icon/LifebuoyScaleMedium';
import LifebuoyScaleSmall from 'bloko/blocks/icon/variants/icon/LifebuoyScaleSmall';
import LinkScaleMedium from 'bloko/blocks/icon/variants/icon/LinkScaleMedium';
import LinkScaleSmall from 'bloko/blocks/icon/variants/icon/LinkScaleSmall';
import ListScaleMediumReducedFalse from 'bloko/blocks/icon/variants/icon/ListScaleMediumReducedFalse';
import ListScaleMediumReducedTrue from 'bloko/blocks/icon/variants/icon/ListScaleMediumReducedTrue';
import ListScaleSmallReducedFalse from 'bloko/blocks/icon/variants/icon/ListScaleSmallReducedFalse';
import ListScaleSmallReducedTrue from 'bloko/blocks/icon/variants/icon/ListScaleSmallReducedTrue';
import LoaderScaleMedium from 'bloko/blocks/icon/variants/icon/LoaderScaleMedium';
import LoaderScaleSmall from 'bloko/blocks/icon/variants/icon/LoaderScaleSmall';
import LocationScaleMedium from 'bloko/blocks/icon/variants/icon/LocationScaleMedium';
import LocationScaleSmall from 'bloko/blocks/icon/variants/icon/LocationScaleSmall';
import LockScaleExtraSmallKindLocked from 'bloko/blocks/icon/variants/icon/LockScaleExtraSmallKindLocked';
import LockScaleExtraSmallKindUnlocked from 'bloko/blocks/icon/variants/icon/LockScaleExtraSmallKindUnlocked';
import LockScaleMediumKindLocked from 'bloko/blocks/icon/variants/icon/LockScaleMediumKindLocked';
import LockScaleMediumKindUnlocked from 'bloko/blocks/icon/variants/icon/LockScaleMediumKindUnlocked';
import LockScaleSmallKindLocked from 'bloko/blocks/icon/variants/icon/LockScaleSmallKindLocked';
import LockScaleSmallKindUnlocked from 'bloko/blocks/icon/variants/icon/LockScaleSmallKindUnlocked';
import LupaScaleMediumKindDefaultAppearanceOutlined from 'bloko/blocks/icon/variants/icon/LupaScaleMediumKindDefaultAppearanceOutlined';
import LupaScaleMediumKindHeartAppearanceFilled from 'bloko/blocks/icon/variants/icon/LupaScaleMediumKindHeartAppearanceFilled';
import LupaScaleMediumKindHeartAppearanceOutlined from 'bloko/blocks/icon/variants/icon/LupaScaleMediumKindHeartAppearanceOutlined';
import LupaScaleSmallKindDefaultAppearanceOutlined from 'bloko/blocks/icon/variants/icon/LupaScaleSmallKindDefaultAppearanceOutlined';
import LupaScaleSmallKindHeartAppearanceFilled from 'bloko/blocks/icon/variants/icon/LupaScaleSmallKindHeartAppearanceFilled';
import LupaScaleSmallKindHeartAppearanceOutlined from 'bloko/blocks/icon/variants/icon/LupaScaleSmallKindHeartAppearanceOutlined';
import MapPinScaleLargeAppearanceFilled from 'bloko/blocks/icon/variants/icon/MapPinScaleLargeAppearanceFilled';
import MapPinScaleLargeAppearanceOutlined from 'bloko/blocks/icon/variants/icon/MapPinScaleLargeAppearanceOutlined';
import MapPinScaleMediumAppearanceFilled from 'bloko/blocks/icon/variants/icon/MapPinScaleMediumAppearanceFilled';
import MapPinScaleMediumAppearanceOutlined from 'bloko/blocks/icon/variants/icon/MapPinScaleMediumAppearanceOutlined';
import MapPinScaleSmallAppearanceFilled from 'bloko/blocks/icon/variants/icon/MapPinScaleSmallAppearanceFilled';
import MapPinScaleSmallAppearanceOutlined from 'bloko/blocks/icon/variants/icon/MapPinScaleSmallAppearanceOutlined';
import MapScaleMedium from 'bloko/blocks/icon/variants/icon/MapScaleMedium';
import MapScaleSmall from 'bloko/blocks/icon/variants/icon/MapScaleSmall';
import MinusScaleMediumEnclosedFalse from 'bloko/blocks/icon/variants/icon/MinusScaleMediumEnclosedFalse';
import MinusScaleMediumEnclosedTrue from 'bloko/blocks/icon/variants/icon/MinusScaleMediumEnclosedTrue';
import MinusScaleSmallEnclosedFalse from 'bloko/blocks/icon/variants/icon/MinusScaleSmallEnclosedFalse';
import MinusScaleSmallEnclosedTrue from 'bloko/blocks/icon/variants/icon/MinusScaleSmallEnclosedTrue';
import PauseScaleMedium from 'bloko/blocks/icon/variants/icon/PauseScaleMedium';
import PauseScaleSmall from 'bloko/blocks/icon/variants/icon/PauseScaleSmall';
import PenSquareScaleMedium from 'bloko/blocks/icon/variants/icon/PenSquareScaleMedium';
import PenSquareScaleSmall from 'bloko/blocks/icon/variants/icon/PenSquareScaleSmall';
import PhoneScaleMediumKindArrowIn from 'bloko/blocks/icon/variants/icon/PhoneScaleMediumKindArrowIn';
import PhoneScaleMediumKindArrowOut from 'bloko/blocks/icon/variants/icon/PhoneScaleMediumKindArrowOut';
import PhoneScaleMediumKindCross from 'bloko/blocks/icon/variants/icon/PhoneScaleMediumKindCross';
import PhoneScaleMediumKindDefault from 'bloko/blocks/icon/variants/icon/PhoneScaleMediumKindDefault';
import PhoneScaleMediumKindWave from 'bloko/blocks/icon/variants/icon/PhoneScaleMediumKindWave';
import PhoneScaleSmallKindArrowIn from 'bloko/blocks/icon/variants/icon/PhoneScaleSmallKindArrowIn';
import PhoneScaleSmallKindArrowOut from 'bloko/blocks/icon/variants/icon/PhoneScaleSmallKindArrowOut';
import PhoneScaleSmallKindCross from 'bloko/blocks/icon/variants/icon/PhoneScaleSmallKindCross';
import PhoneScaleSmallKindDefault from 'bloko/blocks/icon/variants/icon/PhoneScaleSmallKindDefault';
import PhoneScaleSmallKindWave from 'bloko/blocks/icon/variants/icon/PhoneScaleSmallKindWave';
import PinScaleMediumAppearanceFilledCrossedFalse from 'bloko/blocks/icon/variants/icon/PinScaleMediumAppearanceFilledCrossedFalse';
import PinScaleMediumAppearanceFilledCrossedTrue from 'bloko/blocks/icon/variants/icon/PinScaleMediumAppearanceFilledCrossedTrue';
import PinScaleMediumAppearanceOutlinedCrossedFalse from 'bloko/blocks/icon/variants/icon/PinScaleMediumAppearanceOutlinedCrossedFalse';
import PinScaleMediumAppearanceOutlinedCrossedTrue from 'bloko/blocks/icon/variants/icon/PinScaleMediumAppearanceOutlinedCrossedTrue';
import PinScaleSmallAppearanceFilledCrossedFalse from 'bloko/blocks/icon/variants/icon/PinScaleSmallAppearanceFilledCrossedFalse';
import PinScaleSmallAppearanceFilledCrossedTrue from 'bloko/blocks/icon/variants/icon/PinScaleSmallAppearanceFilledCrossedTrue';
import PinScaleSmallAppearanceOutlinedCrossedFalse from 'bloko/blocks/icon/variants/icon/PinScaleSmallAppearanceOutlinedCrossedFalse';
import PinScaleSmallAppearanceOutlinedCrossedTrue from 'bloko/blocks/icon/variants/icon/PinScaleSmallAppearanceOutlinedCrossedTrue';
import PlayScaleMedium from 'bloko/blocks/icon/variants/icon/PlayScaleMedium';
import PlayScaleSmall from 'bloko/blocks/icon/variants/icon/PlayScaleSmall';
import PlusScaleMediumEnclosedFalse from 'bloko/blocks/icon/variants/icon/PlusScaleMediumEnclosedFalse';
import PlusScaleMediumEnclosedTrue from 'bloko/blocks/icon/variants/icon/PlusScaleMediumEnclosedTrue';
import PlusScaleSmallEnclosedFalse from 'bloko/blocks/icon/variants/icon/PlusScaleSmallEnclosedFalse';
import PlusScaleSmallEnclosedTrue from 'bloko/blocks/icon/variants/icon/PlusScaleSmallEnclosedTrue';
import PrinterScaleMedium from 'bloko/blocks/icon/variants/icon/PrinterScaleMedium';
import PrinterScaleSmall from 'bloko/blocks/icon/variants/icon/PrinterScaleSmall';
import QuestionMarkScaleMedium from 'bloko/blocks/icon/variants/icon/QuestionMarkScaleMedium';
import QuestionMarkScaleSmall from 'bloko/blocks/icon/variants/icon/QuestionMarkScaleSmall';
import SendScaleLargeAppearanceFilled from 'bloko/blocks/icon/variants/icon/SendScaleLargeAppearanceFilled';
import SendScaleLargeAppearanceOutlined from 'bloko/blocks/icon/variants/icon/SendScaleLargeAppearanceOutlined';
import SendScaleMediumAppearanceFilled from 'bloko/blocks/icon/variants/icon/SendScaleMediumAppearanceFilled';
import SendScaleMediumAppearanceOutlined from 'bloko/blocks/icon/variants/icon/SendScaleMediumAppearanceOutlined';
import SendScaleSmallAppearanceFilled from 'bloko/blocks/icon/variants/icon/SendScaleSmallAppearanceFilled';
import SendScaleSmallAppearanceOutlined from 'bloko/blocks/icon/variants/icon/SendScaleSmallAppearanceOutlined';
import ShareScaleMedium from 'bloko/blocks/icon/variants/icon/ShareScaleMedium';
import ShareScaleSmall from 'bloko/blocks/icon/variants/icon/ShareScaleSmall';
import SmileyKindHappy from 'bloko/blocks/icon/variants/icon/SmileyKindHappy';
import SmileyKindIndiferent from 'bloko/blocks/icon/variants/icon/SmileyKindIndiferent';
import SmileyKindSad from 'bloko/blocks/icon/variants/icon/SmileyKindSad';
import SmileyKindSmirk from 'bloko/blocks/icon/variants/icon/SmileyKindSmirk';
import SmileyKindUnhappy from 'bloko/blocks/icon/variants/icon/SmileyKindUnhappy';
import SpeedometerScaleMedium from 'bloko/blocks/icon/variants/icon/SpeedometerScaleMedium';
import SpeedometerScaleSmall from 'bloko/blocks/icon/variants/icon/SpeedometerScaleSmall';
import SquaresScaleMediumIntersectFalse from 'bloko/blocks/icon/variants/icon/SquaresScaleMediumIntersectFalse';
import SquaresScaleMediumIntersectTrue from 'bloko/blocks/icon/variants/icon/SquaresScaleMediumIntersectTrue';
import SquaresScaleSmallIntersectFalse from 'bloko/blocks/icon/variants/icon/SquaresScaleSmallIntersectFalse';
import SquaresScaleSmallIntersectTrue from 'bloko/blocks/icon/variants/icon/SquaresScaleSmallIntersectTrue';
import StarScaleMediumAppearanceFilledEnclosedFalse from 'bloko/blocks/icon/variants/icon/StarScaleMediumAppearanceFilledEnclosedFalse';
import StarScaleMediumAppearanceHalfFilledEnclosedFalse from 'bloko/blocks/icon/variants/icon/StarScaleMediumAppearanceHalfFilledEnclosedFalse';
import StarScaleMediumAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/StarScaleMediumAppearanceOutlinedEnclosedFalse';
import StarScaleMediumAppearanceOutlinedEnclosedTrue from 'bloko/blocks/icon/variants/icon/StarScaleMediumAppearanceOutlinedEnclosedTrue';
import StarScaleSmallAppearanceFilledEnclosedFalse from 'bloko/blocks/icon/variants/icon/StarScaleSmallAppearanceFilledEnclosedFalse';
import StarScaleSmallAppearanceHalfFilledEnclosedFalse from 'bloko/blocks/icon/variants/icon/StarScaleSmallAppearanceHalfFilledEnclosedFalse';
import StarScaleSmallAppearanceOutlinedEnclosedFalse from 'bloko/blocks/icon/variants/icon/StarScaleSmallAppearanceOutlinedEnclosedFalse';
import StarScaleSmallAppearanceOutlinedEnclosedTrue from 'bloko/blocks/icon/variants/icon/StarScaleSmallAppearanceOutlinedEnclosedTrue';
import ThumbScaleMediumKindDownDownReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindDownDownReducedTrue';
import ThumbScaleMediumKindDownReducedFalse from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindDownReducedFalse';
import ThumbScaleMediumKindDownReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindDownReducedTrue';
import ThumbScaleMediumKindUpDownReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindUpDownReducedTrue';
import ThumbScaleMediumKindUpReducedFalse from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindUpReducedFalse';
import ThumbScaleMediumKindUpReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindUpReducedTrue';
import ThumbScaleMediumKindUpUpReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleMediumKindUpUpReducedTrue';
import ThumbScaleSmallKindDownDownReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindDownDownReducedTrue';
import ThumbScaleSmallKindDownReducedFalse from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindDownReducedFalse';
import ThumbScaleSmallKindDownReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindDownReducedTrue';
import ThumbScaleSmallKindUpDownReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindUpDownReducedTrue';
import ThumbScaleSmallKindUpReducedFalse from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindUpReducedFalse';
import ThumbScaleSmallKindUpReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindUpReducedTrue';
import ThumbScaleSmallKindUpUpReducedTrue from 'bloko/blocks/icon/variants/icon/ThumbScaleSmallKindUpUpReducedTrue';
import TrashScaleMedium from 'bloko/blocks/icon/variants/icon/TrashScaleMedium';
import TrashScaleSmall from 'bloko/blocks/icon/variants/icon/TrashScaleSmall';
import UserScaleMediumKindDoubleEnclosedFalse from 'bloko/blocks/icon/variants/icon/UserScaleMediumKindDoubleEnclosedFalse';
import UserScaleMediumKindSingleEnclosedFalse from 'bloko/blocks/icon/variants/icon/UserScaleMediumKindSingleEnclosedFalse';
import UserScaleMediumKindSingleEnclosedTrue from 'bloko/blocks/icon/variants/icon/UserScaleMediumKindSingleEnclosedTrue';
import UserScaleSmallKindDoubleEnclosedFalse from 'bloko/blocks/icon/variants/icon/UserScaleSmallKindDoubleEnclosedFalse';
import UserScaleSmallKindSingleEnclosedFalse from 'bloko/blocks/icon/variants/icon/UserScaleSmallKindSingleEnclosedFalse';
import UserScaleSmallKindSingleEnclosedTrue from 'bloko/blocks/icon/variants/icon/UserScaleSmallKindSingleEnclosedTrue';
import UturnScaleMediumKindLeft from 'bloko/blocks/icon/variants/icon/UturnScaleMediumKindLeft';
import UturnScaleMediumKindRight from 'bloko/blocks/icon/variants/icon/UturnScaleMediumKindRight';
import UturnScaleSmallKindLeft from 'bloko/blocks/icon/variants/icon/UturnScaleSmallKindLeft';
import UturnScaleSmallKindRight from 'bloko/blocks/icon/variants/icon/UturnScaleSmallKindRight';
import WalletScaleMedium from 'bloko/blocks/icon/variants/icon/WalletScaleMedium';
import WalletScaleSmall from 'bloko/blocks/icon/variants/icon/WalletScaleSmall';
import {
    IconScale,
    IconKind,
    IconEnclosed,
    IconAppearance,
    IconShape,
    IconReduced,
    IconCrossed,
    IconIntersect,
    IconView,
} from 'bloko/blocks/icon/variants/icon/types.d';

interface IconSwitcherProps {
    scale?: IconScale;
    kind?: IconKind;
    enclosed?: IconEnclosed;
    appearance?: IconAppearance;
    shape?: IconShape;
    reduced?: IconReduced;
    crossed?: IconCrossed;
    intersect?: IconIntersect;
    view: IconView;
}

export default ({
    scale,
    kind,
    enclosed,
    appearance,
    shape,
    reduced,
    crossed,
    intersect,
    view,
}: IconSwitcherProps): ComponentType | null => {
    switch (view) {
        case IconView.Phone:
            if (scale === 'Small' && kind === 'Cross') {
                return PhoneScaleSmallKindCross;
            }
            if (scale === 'Small' && kind === 'ArrowIn') {
                return PhoneScaleSmallKindArrowIn;
            }
            if (scale === 'Small' && kind === 'Default') {
                return PhoneScaleSmallKindDefault;
            }
            if (scale === 'Small' && kind === 'ArrowOut') {
                return PhoneScaleSmallKindArrowOut;
            }
            if (scale === 'Small' && kind === 'Wave') {
                return PhoneScaleSmallKindWave;
            }
            if (scale === 'Medium' && kind === 'Cross') {
                return PhoneScaleMediumKindCross;
            }
            if (scale === 'Medium' && kind === 'ArrowIn') {
                return PhoneScaleMediumKindArrowIn;
            }
            if (scale === 'Medium' && kind === 'Default') {
                return PhoneScaleMediumKindDefault;
            }
            if (scale === 'Medium' && kind === 'ArrowOut') {
                return PhoneScaleMediumKindArrowOut;
            }
            if (scale === 'Medium' && kind === 'Wave') {
                return PhoneScaleMediumKindWave;
            }
            break;
        case IconView.Cross:
            if (scale === 'Small' && enclosed) {
                return CrossScaleSmallEnclosedTrue;
            }
            if (scale === 'Small' && !enclosed) {
                return CrossScaleSmallEnclosedFalse;
            }
            if (scale === 'Medium' && enclosed) {
                return CrossScaleMediumEnclosedTrue;
            }
            if (scale === 'Medium' && !enclosed) {
                return CrossScaleMediumEnclosedFalse;
            }
            break;
        case IconView.Astrostar:
            if (scale === 'Medium') {
                return AstrostarScaleMedium;
            }
            if (scale === 'Small') {
                return AstrostarScaleSmall;
            }
            break;
        case IconView.Lupa:
            if (scale === 'Small' && kind === 'Heart' && appearance === 'Outlined') {
                return LupaScaleSmallKindHeartAppearanceOutlined;
            }
            if (scale === 'Small' && kind === 'Heart' && appearance === 'Filled') {
                return LupaScaleSmallKindHeartAppearanceFilled;
            }
            if (scale === 'Small' && kind === 'Default' && appearance === 'Outlined') {
                return LupaScaleSmallKindDefaultAppearanceOutlined;
            }
            if (scale === 'Medium' && kind === 'Heart' && appearance === 'Outlined') {
                return LupaScaleMediumKindHeartAppearanceOutlined;
            }
            if (scale === 'Medium' && kind === 'Heart' && appearance === 'Filled') {
                return LupaScaleMediumKindHeartAppearanceFilled;
            }
            if (scale === 'Medium' && kind === 'Default' && appearance === 'Outlined') {
                return LupaScaleMediumKindDefaultAppearanceOutlined;
            }
            break;
        case IconView.Folder:
            if (kind === 'Arrow' && scale === 'Small') {
                return FolderKindArrowScaleSmall;
            }
            if (kind === 'Arrow' && scale === 'Medium') {
                return FolderKindArrowScaleMedium;
            }
            if (kind === 'Default' && scale === 'Small') {
                return FolderKindDefaultScaleSmall;
            }
            if (kind === 'Default' && scale === 'Medium') {
                return FolderKindDefaultScaleMedium;
            }
            if (kind === 'Heart' && scale === 'Small') {
                return FolderKindHeartScaleSmall;
            }
            if (kind === 'Heart' && scale === 'Medium') {
                return FolderKindHeartScaleMedium;
            }
            break;
        case IconView.Share:
            if (scale === 'Small') {
                return ShareScaleSmall;
            }
            if (scale === 'Medium') {
                return ShareScaleMedium;
            }
            break;
        case IconView.Bubble:
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Filled' && shape === 'Square') {
                return BubbleScaleMediumKindSingleAppearanceFilledShapeSquare;
            }
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Filled' && shape === 'Round') {
                return BubbleScaleMediumKindSingleAppearanceFilledShapeRound;
            }
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Outlined' && shape === 'Square') {
                return BubbleScaleMediumKindSingleAppearanceOutlinedShapeSquare;
            }
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Outlined' && shape === 'Round') {
                return BubbleScaleMediumKindSingleAppearanceOutlinedShapeRound;
            }
            if (scale === 'Medium' && kind === 'Double' && appearance === 'Outlined' && shape === 'Round') {
                return BubbleScaleMediumKindDoubleAppearanceOutlinedShapeRound;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Filled' && shape === 'Square') {
                return BubbleScaleSmallKindSingleAppearanceFilledShapeSquare;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Filled' && shape === 'Round') {
                return BubbleScaleSmallKindSingleAppearanceFilledShapeRound;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Outlined' && shape === 'Square') {
                return BubbleScaleSmallKindSingleAppearanceOutlinedShapeSquare;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Outlined' && shape === 'Round') {
                return BubbleScaleSmallKindSingleAppearanceOutlinedShapeRound;
            }
            if (scale === 'Small' && kind === 'Double' && appearance === 'Outlined' && shape === 'Round') {
                return BubbleScaleSmallKindDoubleAppearanceOutlinedShapeRound;
            }
            break;
        case IconView.List:
            if (scale === 'Small' && !reduced) {
                return ListScaleSmallReducedFalse;
            }
            if (scale === 'Small' && reduced) {
                return ListScaleSmallReducedTrue;
            }
            if (scale === 'Medium' && !reduced) {
                return ListScaleMediumReducedFalse;
            }
            if (scale === 'Medium' && reduced) {
                return ListScaleMediumReducedTrue;
            }
            break;
        case IconView.Speedometer:
            if (scale === 'Small') {
                return SpeedometerScaleSmall;
            }
            if (scale === 'Medium') {
                return SpeedometerScaleMedium;
            }
            break;
        case IconView.Ghost:
            if (scale === 'Medium') {
                return GhostScaleMedium;
            }
            if (scale === 'Small') {
                return GhostScaleSmall;
            }
            break;
        case IconView.Gift:
            if (scale === 'Medium') {
                return GiftScaleMedium;
            }
            if (scale === 'Small') {
                return GiftScaleSmall;
            }
            break;
        case IconView.Cart:
            if (scale === 'Small') {
                return CartScaleSmall;
            }
            if (scale === 'Medium') {
                return CartScaleMedium;
            }
            break;
        case IconView.Location:
            if (scale === 'Small') {
                return LocationScaleSmall;
            }
            if (scale === 'Medium') {
                return LocationScaleMedium;
            }
            break;
        case IconView.QuestionMark:
            if (scale === 'Small') {
                return QuestionMarkScaleSmall;
            }
            if (scale === 'Medium') {
                return QuestionMarkScaleMedium;
            }
            break;
        case IconView.Lifebuoy:
            if (scale === 'Medium') {
                return LifebuoyScaleMedium;
            }
            if (scale === 'Small') {
                return LifebuoyScaleSmall;
            }
            break;
        case IconView.Eye:
            if (scale === 'MediumSmall' && !crossed) {
                return EyeScaleMediumSmallCrossedFalse;
            }
            if (scale === 'MediumSmall' && crossed) {
                return EyeScaleMediumSmallCrossedTrue;
            }
            if (scale === 'Small' && !crossed) {
                return EyeScaleSmallCrossedFalse;
            }
            if (scale === 'Small' && crossed) {
                return EyeScaleSmallCrossedTrue;
            }
            if (scale === 'Medium' && !crossed) {
                return EyeScaleMediumCrossedFalse;
            }
            if (scale === 'Medium' && crossed) {
                return EyeScaleMediumCrossedTrue;
            }
            break;
        case IconView.Chevron:
            if (scale === 'ExtraSmall' && kind === 'Up') {
                return ChevronScaleExtraSmallKindUp;
            }
            if (scale === 'ExtraSmall' && kind === 'UpDown') {
                return ChevronScaleExtraSmallKindUpDown;
            }
            if (scale === 'ExtraSmall' && kind === 'Down') {
                return ChevronScaleExtraSmallKindDown;
            }
            if (scale === 'ExtraSmall' && kind === 'Left') {
                return ChevronScaleExtraSmallKindLeft;
            }
            if (scale === 'ExtraSmall' && kind === 'Right') {
                return ChevronScaleExtraSmallKindRight;
            }
            if (scale === 'Small' && kind === 'Up') {
                return ChevronScaleSmallKindUp;
            }
            if (scale === 'Small' && kind === 'UpDown') {
                return ChevronScaleSmallKindUpDown;
            }
            if (scale === 'Small' && kind === 'Down') {
                return ChevronScaleSmallKindDown;
            }
            if (scale === 'Small' && kind === 'Left') {
                return ChevronScaleSmallKindLeft;
            }
            if (scale === 'Small' && kind === 'Right') {
                return ChevronScaleSmallKindRight;
            }
            if (scale === 'Medium' && kind === 'Up') {
                return ChevronScaleMediumKindUp;
            }
            if (scale === 'Medium' && kind === 'UpDown') {
                return ChevronScaleMediumKindUpDown;
            }
            if (scale === 'Medium' && kind === 'Down') {
                return ChevronScaleMediumKindDown;
            }
            if (scale === 'Medium' && kind === 'Left') {
                return ChevronScaleMediumKindLeft;
            }
            if (scale === 'Medium' && kind === 'Right') {
                return ChevronScaleMediumKindRight;
            }
            break;
        case IconView.Thumb:
            if (scale === 'Small' && kind === 'Down' && reduced) {
                return ThumbScaleSmallKindDownReducedTrue;
            }
            if (scale === 'Small' && kind === 'Down' && !reduced) {
                return ThumbScaleSmallKindDownReducedFalse;
            }
            if (scale === 'Small' && kind === 'DownDown' && reduced) {
                return ThumbScaleSmallKindDownDownReducedTrue;
            }
            if (scale === 'Small' && kind === 'UpDown' && reduced) {
                return ThumbScaleSmallKindUpDownReducedTrue;
            }
            if (scale === 'Small' && kind === 'Up' && reduced) {
                return ThumbScaleSmallKindUpReducedTrue;
            }
            if (scale === 'Small' && kind === 'Up' && !reduced) {
                return ThumbScaleSmallKindUpReducedFalse;
            }
            if (scale === 'Small' && kind === 'UpUp' && reduced) {
                return ThumbScaleSmallKindUpUpReducedTrue;
            }
            if (scale === 'Medium' && kind === 'Down' && reduced) {
                return ThumbScaleMediumKindDownReducedTrue;
            }
            if (scale === 'Medium' && kind === 'Down' && !reduced) {
                return ThumbScaleMediumKindDownReducedFalse;
            }
            if (scale === 'Medium' && kind === 'DownDown' && reduced) {
                return ThumbScaleMediumKindDownDownReducedTrue;
            }
            if (scale === 'Medium' && kind === 'UpDown' && reduced) {
                return ThumbScaleMediumKindUpDownReducedTrue;
            }
            if (scale === 'Medium' && kind === 'Up' && reduced) {
                return ThumbScaleMediumKindUpReducedTrue;
            }
            if (scale === 'Medium' && kind === 'Up' && !reduced) {
                return ThumbScaleMediumKindUpReducedFalse;
            }
            if (scale === 'Medium' && kind === 'UpUp' && reduced) {
                return ThumbScaleMediumKindUpUpReducedTrue;
            }
            break;
        case IconView.Smiley:
            if (kind === 'Sad') {
                return SmileyKindSad;
            }
            if (kind === 'Smirk') {
                return SmileyKindSmirk;
            }
            if (kind === 'Unhappy') {
                return SmileyKindUnhappy;
            }
            if (kind === 'Happy') {
                return SmileyKindHappy;
            }
            if (kind === 'Indiferent') {
                return SmileyKindIndiferent;
            }
            break;
        case IconView.Uturn:
            if (scale === 'Medium' && kind === 'Right') {
                return UturnScaleMediumKindRight;
            }
            if (scale === 'Medium' && kind === 'Left') {
                return UturnScaleMediumKindLeft;
            }
            if (scale === 'Small' && kind === 'Right') {
                return UturnScaleSmallKindRight;
            }
            if (scale === 'Small' && kind === 'Left') {
                return UturnScaleSmallKindLeft;
            }
            break;
        case IconView.ArrowPath:
            if (scale === 'Medium' && kind === 'Clockwise') {
                return ArrowPathScaleMediumKindClockwise;
            }
            if (scale === 'Medium' && kind === 'Default') {
                return ArrowPathScaleMediumKindDefault;
            }
            if (scale === 'Small' && kind === 'Clockwise') {
                return ArrowPathScaleSmallKindClockwise;
            }
            if (scale === 'Small' && kind === 'Default') {
                return ArrowPathScaleSmallKindDefault;
            }
            break;
        case IconView.User:
            if (scale === 'Medium' && kind === 'Double' && !enclosed) {
                return UserScaleMediumKindDoubleEnclosedFalse;
            }
            if (scale === 'Medium' && kind === 'Single' && !enclosed) {
                return UserScaleMediumKindSingleEnclosedFalse;
            }
            if (scale === 'Medium' && kind === 'Single' && enclosed) {
                return UserScaleMediumKindSingleEnclosedTrue;
            }
            if (scale === 'Small' && kind === 'Double' && !enclosed) {
                return UserScaleSmallKindDoubleEnclosedFalse;
            }
            if (scale === 'Small' && kind === 'Single' && !enclosed) {
                return UserScaleSmallKindSingleEnclosedFalse;
            }
            if (scale === 'Small' && kind === 'Single' && enclosed) {
                return UserScaleSmallKindSingleEnclosedTrue;
            }
            break;
        case IconView.Trash:
            if (scale === 'Medium') {
                return TrashScaleMedium;
            }
            if (scale === 'Small') {
                return TrashScaleSmall;
            }
            break;
        case IconView.PenSquare:
            if (scale === 'Medium') {
                return PenSquareScaleMedium;
            }
            if (scale === 'Small') {
                return PenSquareScaleSmall;
            }
            break;
        case IconView.Clock:
            if (scale === 'ExtraSmall' && kind === 'Default') {
                return ClockScaleExtraSmallKindDefault;
            }
            if (scale === 'ExtraSmall' && kind === 'Rewind') {
                return ClockScaleExtraSmallKindRewind;
            }
            if (scale === 'Small' && kind === 'Default') {
                return ClockScaleSmallKindDefault;
            }
            if (scale === 'Small' && kind === 'Rewind') {
                return ClockScaleSmallKindRewind;
            }
            if (scale === 'Medium' && kind === 'Default') {
                return ClockScaleMediumKindDefault;
            }
            if (scale === 'Medium' && kind === 'Rewind') {
                return ClockScaleMediumKindRewind;
            }
            break;
        case IconView.Camera:
            if (scale === 'Small') {
                return CameraScaleSmall;
            }
            if (scale === 'Medium') {
                return CameraScaleMedium;
            }
            break;
        case IconView.Flag:
            if (scale === 'Small') {
                return FlagScaleSmall;
            }
            if (scale === 'Medium') {
                return FlagScaleMedium;
            }
            break;
        case IconView.Minus:
            if (scale === 'Medium' && enclosed) {
                return MinusScaleMediumEnclosedTrue;
            }
            if (scale === 'Medium' && !enclosed) {
                return MinusScaleMediumEnclosedFalse;
            }
            if (scale === 'Small' && enclosed) {
                return MinusScaleSmallEnclosedTrue;
            }
            if (scale === 'Small' && !enclosed) {
                return MinusScaleSmallEnclosedFalse;
            }
            break;
        case IconView.Lock:
            if (scale === 'Medium' && kind === 'Unlocked') {
                return LockScaleMediumKindUnlocked;
            }
            if (scale === 'Medium' && kind === 'Locked') {
                return LockScaleMediumKindLocked;
            }
            if (scale === 'Small' && kind === 'Unlocked') {
                return LockScaleSmallKindUnlocked;
            }
            if (scale === 'Small' && kind === 'Locked') {
                return LockScaleSmallKindLocked;
            }
            if (scale === 'ExtraSmall' && kind === 'Unlocked') {
                return LockScaleExtraSmallKindUnlocked;
            }
            if (scale === 'ExtraSmall' && kind === 'Locked') {
                return LockScaleExtraSmallKindLocked;
            }
            break;
        case IconView.Chart:
            if (scale === 'Small' && kind === 'Bar') {
                return ChartScaleSmallKindBar;
            }
            if (scale === 'Small' && kind === 'Line') {
                return ChartScaleSmallKindLine;
            }
            if (scale === 'Medium' && kind === 'Bar') {
                return ChartScaleMediumKindBar;
            }
            if (scale === 'Medium' && kind === 'Line') {
                return ChartScaleMediumKindLine;
            }
            break;
        case IconView.Send:
            if (scale === 'Large' && appearance === 'Outlined') {
                return SendScaleLargeAppearanceOutlined;
            }
            if (scale === 'Large' && appearance === 'Filled') {
                return SendScaleLargeAppearanceFilled;
            }
            if (scale === 'Medium' && appearance === 'Outlined') {
                return SendScaleMediumAppearanceOutlined;
            }
            if (scale === 'Medium' && appearance === 'Filled') {
                return SendScaleMediumAppearanceFilled;
            }
            if (scale === 'Small' && appearance === 'Outlined') {
                return SendScaleSmallAppearanceOutlined;
            }
            if (scale === 'Small' && appearance === 'Filled') {
                return SendScaleSmallAppearanceFilled;
            }
            break;
        case IconView.Bars:
            if (scale === 'Medium') {
                return BarsScaleMedium;
            }
            if (scale === 'Small') {
                return BarsScaleSmall;
            }
            break;
        case IconView.Wallet:
            if (scale === 'Medium') {
                return WalletScaleMedium;
            }
            if (scale === 'Small') {
                return WalletScaleSmall;
            }
            break;
        case IconView.Play:
            if (scale === 'Small') {
                return PlayScaleSmall;
            }
            if (scale === 'Medium') {
                return PlayScaleMedium;
            }
            break;
        case IconView.Ellipsis:
            if (scale === 'Medium' && kind === 'Vertical') {
                return EllipsisScaleMediumKindVertical;
            }
            if (scale === 'Medium' && kind === 'Horizontal') {
                return EllipsisScaleMediumKindHorizontal;
            }
            if (scale === 'Small' && kind === 'Vertical') {
                return EllipsisScaleSmallKindVertical;
            }
            if (scale === 'Small' && kind === 'Horizontal') {
                return EllipsisScaleSmallKindHorizontal;
            }
            break;
        case IconView.Star:
            if (scale === 'Medium' && appearance === 'Outlined' && !enclosed) {
                return StarScaleMediumAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'Medium' && appearance === 'Outlined' && enclosed) {
                return StarScaleMediumAppearanceOutlinedEnclosedTrue;
            }
            if (scale === 'Medium' && appearance === 'HalfFilled' && !enclosed) {
                return StarScaleMediumAppearanceHalfFilledEnclosedFalse;
            }
            if (scale === 'Medium' && appearance === 'Filled' && !enclosed) {
                return StarScaleMediumAppearanceFilledEnclosedFalse;
            }
            if (scale === 'Small' && appearance === 'Outlined' && !enclosed) {
                return StarScaleSmallAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'Small' && appearance === 'Outlined' && enclosed) {
                return StarScaleSmallAppearanceOutlinedEnclosedTrue;
            }
            if (scale === 'Small' && appearance === 'HalfFilled' && !enclosed) {
                return StarScaleSmallAppearanceHalfFilledEnclosedFalse;
            }
            if (scale === 'Small' && appearance === 'Filled' && !enclosed) {
                return StarScaleSmallAppearanceFilledEnclosedFalse;
            }
            break;
        case IconView.Pause:
            if (scale === 'Small') {
                return PauseScaleSmall;
            }
            if (scale === 'Medium') {
                return PauseScaleMedium;
            }
            break;
        case IconView.MapPin:
            if (scale === 'Medium' && appearance === 'Outlined') {
                return MapPinScaleMediumAppearanceOutlined;
            }
            if (scale === 'Medium' && appearance === 'Filled') {
                return MapPinScaleMediumAppearanceFilled;
            }
            if (scale === 'Large' && appearance === 'Outlined') {
                return MapPinScaleLargeAppearanceOutlined;
            }
            if (scale === 'Large' && appearance === 'Filled') {
                return MapPinScaleLargeAppearanceFilled;
            }
            if (scale === 'Small' && appearance === 'Outlined') {
                return MapPinScaleSmallAppearanceOutlined;
            }
            if (scale === 'Small' && appearance === 'Filled') {
                return MapPinScaleSmallAppearanceFilled;
            }
            break;
        case IconView.Bot:
            if (scale === 'Small') {
                return BotScaleSmall;
            }
            if (scale === 'Medium') {
                return BotScaleMedium;
            }
            break;
        case IconView.Pin:
            if (scale === 'Medium' && appearance === 'Outlined' && crossed) {
                return PinScaleMediumAppearanceOutlinedCrossedTrue;
            }
            if (scale === 'Medium' && appearance === 'Outlined' && !crossed) {
                return PinScaleMediumAppearanceOutlinedCrossedFalse;
            }
            if (scale === 'Medium' && appearance === 'Filled' && crossed) {
                return PinScaleMediumAppearanceFilledCrossedTrue;
            }
            if (scale === 'Medium' && appearance === 'Filled' && !crossed) {
                return PinScaleMediumAppearanceFilledCrossedFalse;
            }
            if (scale === 'Small' && appearance === 'Outlined' && crossed) {
                return PinScaleSmallAppearanceOutlinedCrossedTrue;
            }
            if (scale === 'Small' && appearance === 'Outlined' && !crossed) {
                return PinScaleSmallAppearanceOutlinedCrossedFalse;
            }
            if (scale === 'Small' && appearance === 'Filled' && crossed) {
                return PinScaleSmallAppearanceFilledCrossedTrue;
            }
            if (scale === 'Small' && appearance === 'Filled' && !crossed) {
                return PinScaleSmallAppearanceFilledCrossedFalse;
            }
            break;
        case IconView.Heart:
            if (scale === 'Medium' && appearance === 'Filled') {
                return HeartScaleMediumAppearanceFilled;
            }
            if (scale === 'Medium' && appearance === 'Outlined') {
                return HeartScaleMediumAppearanceOutlined;
            }
            if (scale === 'Small' && appearance === 'Filled') {
                return HeartScaleSmallAppearanceFilled;
            }
            if (scale === 'Small' && appearance === 'Outlined') {
                return HeartScaleSmallAppearanceOutlined;
            }
            if (scale === 'MediumSmall' && appearance === 'Filled') {
                return HeartScaleMediumSmallAppearanceFilled;
            }
            if (scale === 'MediumSmall' && appearance === 'Outlined') {
                return HeartScaleMediumSmallAppearanceOutlined;
            }
            break;
        case IconView.Plus:
            if (scale === 'Small' && enclosed) {
                return PlusScaleSmallEnclosedTrue;
            }
            if (scale === 'Small' && !enclosed) {
                return PlusScaleSmallEnclosedFalse;
            }
            if (scale === 'Medium' && enclosed) {
                return PlusScaleMediumEnclosedTrue;
            }
            if (scale === 'Medium' && !enclosed) {
                return PlusScaleMediumEnclosedFalse;
            }
            break;
        case IconView.Dots:
            if (scale === 'Small') {
                return DotsScaleSmall;
            }
            if (scale === 'Medium') {
                return DotsScaleMedium;
            }
            break;
        case IconView.Checkmark:
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Outlined' && !enclosed) {
                return CheckmarkScaleMediumKindSingleAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Outlined' && enclosed) {
                return CheckmarkScaleMediumKindSingleAppearanceOutlinedEnclosedTrue;
            }
            if (scale === 'Medium' && kind === 'Single' && appearance === 'Filled' && enclosed) {
                return CheckmarkScaleMediumKindSingleAppearanceFilledEnclosedTrue;
            }
            if (scale === 'Medium' && kind === 'Double' && appearance === 'Outlined' && !enclosed) {
                return CheckmarkScaleMediumKindDoubleAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'ExtraSmall' && kind === 'Single' && appearance === 'Outlined' && !enclosed) {
                return CheckmarkScaleExtraSmallKindSingleAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'ExtraSmall' && kind === 'Single' && appearance === 'Outlined' && enclosed) {
                return CheckmarkScaleExtraSmallKindSingleAppearanceOutlinedEnclosedTrue;
            }
            if (scale === 'ExtraSmall' && kind === 'Single' && appearance === 'Filled' && enclosed) {
                return CheckmarkScaleExtraSmallKindSingleAppearanceFilledEnclosedTrue;
            }
            if (scale === 'ExtraSmall' && kind === 'Double' && appearance === 'Outlined' && !enclosed) {
                return CheckmarkScaleExtraSmallKindDoubleAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Outlined' && !enclosed) {
                return CheckmarkScaleSmallKindSingleAppearanceOutlinedEnclosedFalse;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Outlined' && enclosed) {
                return CheckmarkScaleSmallKindSingleAppearanceOutlinedEnclosedTrue;
            }
            if (scale === 'Small' && kind === 'Single' && appearance === 'Filled' && enclosed) {
                return CheckmarkScaleSmallKindSingleAppearanceFilledEnclosedTrue;
            }
            if (scale === 'Small' && kind === 'Double' && appearance === 'Outlined' && !enclosed) {
                return CheckmarkScaleSmallKindDoubleAppearanceOutlinedEnclosedFalse;
            }
            break;
        case IconView.Arrows:
            if (scale === 'Medium' && kind === 'DiagonalIn') {
                return ArrowsScaleMediumKindDiagonalIn;
            }
            if (scale === 'Medium' && kind === 'DiagonalOut') {
                return ArrowsScaleMediumKindDiagonalOut;
            }
            if (scale === 'Medium' && kind === 'Default') {
                return ArrowsScaleMediumKindDefault;
            }
            if (scale === 'Small' && kind === 'DiagonalIn') {
                return ArrowsScaleSmallKindDiagonalIn;
            }
            if (scale === 'Small' && kind === 'DiagonalOut') {
                return ArrowsScaleSmallKindDiagonalOut;
            }
            if (scale === 'Small' && kind === 'Default') {
                return ArrowsScaleSmallKindDefault;
            }
            break;
        case IconView.Arrow:
            if (scale === 'Small' && kind === 'Right') {
                return ArrowScaleSmallKindRight;
            }
            if (scale === 'Small' && kind === 'LeftUp') {
                return ArrowScaleSmallKindLeftUp;
            }
            if (scale === 'Small' && kind === 'UpDown') {
                return ArrowScaleSmallKindUpDown;
            }
            if (scale === 'Small' && kind === 'Down') {
                return ArrowScaleSmallKindDown;
            }
            if (scale === 'Small' && kind === 'Left') {
                return ArrowScaleSmallKindLeft;
            }
            if (scale === 'Small' && kind === 'Up') {
                return ArrowScaleSmallKindUp;
            }
            if (scale === 'Medium' && kind === 'Right') {
                return ArrowScaleMediumKindRight;
            }
            if (scale === 'Medium' && kind === 'LeftUp') {
                return ArrowScaleMediumKindLeftUp;
            }
            if (scale === 'Medium' && kind === 'UpDown') {
                return ArrowScaleMediumKindUpDown;
            }
            if (scale === 'Medium' && kind === 'Down') {
                return ArrowScaleMediumKindDown;
            }
            if (scale === 'Medium' && kind === 'Left') {
                return ArrowScaleMediumKindLeft;
            }
            if (scale === 'Medium' && kind === 'Up') {
                return ArrowScaleMediumKindUp;
            }
            break;
        case IconView.Document:
            if (scale === 'Small') {
                return DocumentScaleSmall;
            }
            if (scale === 'Medium') {
                return DocumentScaleMedium;
            }
            break;
        case IconView.Squares:
            if (scale === 'Small' && intersect) {
                return SquaresScaleSmallIntersectTrue;
            }
            if (scale === 'Small' && !intersect) {
                return SquaresScaleSmallIntersectFalse;
            }
            if (scale === 'Medium' && intersect) {
                return SquaresScaleMediumIntersectTrue;
            }
            if (scale === 'Medium' && !intersect) {
                return SquaresScaleMediumIntersectFalse;
            }
            break;
        case IconView.Bell:
            if (scale === 'Small' && !crossed) {
                return BellScaleSmallCrossedFalse;
            }
            if (scale === 'Small' && crossed) {
                return BellScaleSmallCrossedTrue;
            }
            if (scale === 'Medium' && !crossed) {
                return BellScaleMediumCrossedFalse;
            }
            if (scale === 'Medium' && crossed) {
                return BellScaleMediumCrossedTrue;
            }
            break;
        case IconView.Loader:
            if (scale === 'Small') {
                return LoaderScaleSmall;
            }
            if (scale === 'Medium') {
                return LoaderScaleMedium;
            }
            break;
        case IconView.ArrowRectangle:
            if (scale === 'Small') {
                return ArrowRectangleScaleSmall;
            }
            if (scale === 'Medium') {
                return ArrowRectangleScaleMedium;
            }
            break;
        case IconView.Calendar:
            if (scale === 'Medium') {
                return CalendarScaleMedium;
            }
            if (scale === 'Small') {
                return CalendarScaleSmall;
            }
            break;
        case IconView.Grid:
            if (scale === 'Medium') {
                return GridScaleMedium;
            }
            if (scale === 'Small') {
                return GridScaleSmall;
            }
            break;
        case IconView.Link:
            if (scale === 'Small') {
                return LinkScaleSmall;
            }
            if (scale === 'Medium') {
                return LinkScaleMedium;
            }
            break;
        case IconView.ArrowSquare:
            if (scale === 'Medium') {
                return ArrowSquareScaleMedium;
            }
            if (scale === 'Small') {
                return ArrowSquareScaleSmall;
            }
            break;
        case IconView.Box:
            if (scale === 'Small' && kind === 'Default') {
                return BoxScaleSmallKindDefault;
            }
            if (scale === 'Small' && kind === 'Arrow') {
                return BoxScaleSmallKindArrow;
            }
            if (scale === 'Medium' && kind === 'Default') {
                return BoxScaleMediumKindDefault;
            }
            if (scale === 'Medium' && kind === 'Arrow') {
                return BoxScaleMediumKindArrow;
            }
            break;
        case IconView.Funnel:
            if (scale === 'Medium') {
                return FunnelScaleMedium;
            }
            if (scale === 'Small') {
                return FunnelScaleSmall;
            }
            break;
        case IconView.Envelope:
            if (scale === 'Small' && kind === 'Default') {
                return EnvelopeScaleSmallKindDefault;
            }
            if (scale === 'Small' && kind === 'Opened') {
                return EnvelopeScaleSmallKindOpened;
            }
            if (scale === 'Medium' && kind === 'Default') {
                return EnvelopeScaleMediumKindDefault;
            }
            if (scale === 'Medium' && kind === 'Opened') {
                return EnvelopeScaleMediumKindOpened;
            }
            break;
        case IconView.Adjustments:
            if (scale === 'Small') {
                return AdjustmentsScaleSmall;
            }
            if (scale === 'Medium') {
                return AdjustmentsScaleMedium;
            }
            break;
        case IconView.Clip:
            if (scale === 'Medium') {
                return ClipScaleMedium;
            }
            if (scale === 'Small') {
                return ClipScaleSmall;
            }
            break;
        case IconView.Drawer:
            if (scale === 'Medium') {
                return DrawerScaleMedium;
            }
            if (scale === 'Small') {
                return DrawerScaleSmall;
            }
            break;
        case IconView.Dataflow:
            if (scale === 'Medium') {
                return DataflowScaleMedium;
            }
            if (scale === 'Small') {
                return DataflowScaleSmall;
            }
            break;
        case IconView.Book:
            if (scale === 'Medium') {
                return BookScaleMedium;
            }
            if (scale === 'Small') {
                return BookScaleSmall;
            }
            break;
        case IconView.Gear:
            if (scale === 'Small') {
                return GearScaleSmall;
            }
            if (scale === 'Medium') {
                return GearScaleMedium;
            }
            break;
        case IconView.Exclamation:
            if (scale === 'Medium' && shape === 'Circle') {
                return ExclamationScaleMediumShapeCircle;
            }
            if (scale === 'Medium' && shape === 'Triangle') {
                return ExclamationScaleMediumShapeTriangle;
            }
            if (scale === 'Small' && shape === 'Circle') {
                return ExclamationScaleSmallShapeCircle;
            }
            if (scale === 'Small' && shape === 'Triangle') {
                return ExclamationScaleSmallShapeTriangle;
            }
            break;
        case IconView.Info:
            if (scale === 'Small') {
                return InfoScaleSmall;
            }
            if (scale === 'Medium') {
                return InfoScaleMedium;
            }
            break;
        case IconView.Bolt:
            if (scale === 'Small') {
                return BoltScaleSmall;
            }
            if (scale === 'Medium') {
                return BoltScaleMedium;
            }
            break;
        case IconView.ArrowLine:
            if (scale === 'Medium') {
                return ArrowLineScaleMedium;
            }
            if (scale === 'Small') {
                return ArrowLineScaleSmall;
            }
            break;
        case IconView.Ban:
            if (scale === 'Small') {
                return BanScaleSmall;
            }
            if (scale === 'Medium') {
                return BanScaleMedium;
            }
            break;
        case IconView.Map:
            if (scale === 'Medium') {
                return MapScaleMedium;
            }
            if (scale === 'Small') {
                return MapScaleSmall;
            }
            break;
        case IconView.Globe:
            if (scale === 'Small') {
                return GlobeScaleSmall;
            }
            if (scale === 'Medium') {
                return GlobeScaleMedium;
            }
            break;
        case IconView.Briefcase:
            if (scale === 'Medium') {
                return BriefcaseScaleMedium;
            }
            if (scale === 'Small') {
                return BriefcaseScaleSmall;
            }
            break;
        case IconView.Printer:
            if (scale === 'Medium') {
                return PrinterScaleMedium;
            }
            if (scale === 'Small') {
                return PrinterScaleSmall;
            }
            break;
        case IconView.Circle:
            if (scale === 'Small' && appearance === 'Outlined') {
                return CircleScaleSmallAppearanceOutlined;
            }
            if (scale === 'Small' && appearance === 'Filled') {
                return CircleScaleSmallAppearanceFilled;
            }
            if (scale === 'Middle' && appearance === 'Outlined') {
                return CircleScaleMiddleAppearanceOutlined;
            }
            if (scale === 'Middle' && appearance === 'Filled') {
                return CircleScaleMiddleAppearanceFilled;
            }
            break;
    }
    return null;
};
